import type { GeoLevel, MasteredSite } from "../types";

/** All regions a site belongs to — primary bucket first, then overlapping
 * groups (EU, APAC). Falls back to the single legacy field. */
export function siteRegions(site: MasteredSite): string[] {
  return site.regions ?? [site.region];
}

export function buildGeoProfileUrl(
  geoType: GeoLevel,
  geoValue: string,
): string {
  return `site-profiles/geo/${geoType}/${encodeURIComponent(geoValue)}`;
}

export function buildGeoProfileTabUrl(
  geoType: GeoLevel,
  geoValue: string,
  tab: string,
): string {
  return `site-profiles/geo/${geoType}/${encodeURIComponent(geoValue)}/${tab}`;
}
